export default __webpack_public_path__ + "static/jena-beranek-8fb1d0cd814725d9aafaa23e52d73da8.png";